import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "results", "clear"]
  static values = { url: String }

  connect() {
    this.activeIndex = -1
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    document.addEventListener("click", this.handleOutsideClick)
  }

  disconnect() {
    window.clearTimeout(this.searchTimer)
    if (this.abortController) this.abortController.abort()
    document.removeEventListener("click", this.handleOutsideClick)
  }

  search() {
    window.clearTimeout(this.searchTimer)
    this.clearTarget.classList.toggle("d-none", this.inputTarget.value.length === 0)
    this.searchTimer = window.setTimeout(() => this.fetchProviders(), 180)
  }

  fetchProviders() {
    if (this.abortController) this.abortController.abort()
    this.abortController = new AbortController()
    const query = new URLSearchParams({ q: this.inputTarget.value.trim() })

    fetch(`${this.urlValue}?${query.toString()}`, {
      headers: { Accept: "application/json" }, credentials: "same-origin", signal: this.abortController.signal
    })
      .then((response) => {
        if (!response.ok) throw new Error("Provider search failed")
        return response.json()
      })
      .then((providers) => this.renderResults(providers))
      .catch((error) => {
        if (error.name !== "AbortError") this.renderMessage("Unable to load providers.")
      })
  }

  renderResults(providers) {
    this.resultsTarget.replaceChildren()
    this.activeIndex = -1
    if (providers.length === 0) return this.renderMessage("No providers found.")

    providers.forEach((provider) => {
      const button = document.createElement("button")
      button.type = "button"
      button.className = "coverage-provider-result"
      button.setAttribute("role", "option")
      button.textContent = provider.title
      button.addEventListener("click", () => this.select(provider))
      this.resultsTarget.appendChild(button)
    })
    this.resultsTarget.classList.remove("d-none")
  }

  renderMessage(message) {
    const row = document.createElement("p")
    row.className = "coverage-provider-result-message"
    row.textContent = message
    this.resultsTarget.replaceChildren(row)
    this.resultsTarget.classList.remove("d-none")
  }

  select(provider) {
    this.inputTarget.value = provider.title
    this.resultsTarget.classList.add("d-none")
    window.location.assign(`/provider_company_coverages?provider_id=${encodeURIComponent(provider.id)}`)
  }

  clear() {
    this.inputTarget.value = ""
    this.clearTarget.classList.add("d-none")
    this.inputTarget.focus()
    this.fetchProviders()
  }

  navigate(event) {
    const options = Array.from(this.resultsTarget.querySelectorAll(".coverage-provider-result"))
    if (options.length === 0) return
    if (event.key === "ArrowDown") {
      event.preventDefault(); this.activeIndex = Math.min(this.activeIndex + 1, options.length - 1)
    } else if (event.key === "ArrowUp") {
      event.preventDefault(); this.activeIndex = Math.max(this.activeIndex - 1, 0)
    } else if (event.key === "Enter" && this.activeIndex >= 0) {
      event.preventDefault(); options[this.activeIndex].click(); return
    } else if (event.key === "Escape") {
      this.resultsTarget.classList.add("d-none"); return
    } else return

    options.forEach((option, index) => option.classList.toggle("is-active", index === this.activeIndex))
    options[this.activeIndex].scrollIntoView({ block: "nearest" })
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) this.resultsTarget.classList.add("d-none")
  }
}
